import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface AvoirLine {
  id?: number;
  avoirId?: number;
  product: any;
  quantityReturned: number;
  refundSellingPrice?: number;
  refundPurchasePrice?: number;
  isDefective?: boolean;
}

export interface Avoir {
  id?: number;
  originalOrderId: number;
  originalOrder?: any;
  avoirLines: AvoirLine[];
  totalRefund?: number;
  returnedCapital?: number;
  returnedBenefit?: number;
  avoirDate?: Date;
  createdAt?: string;
  approvalDate?: Date;
  status?: 'PENDING' | 'READY_TO_APPROVE' | 'APPROVED' | 'COMPLETED' | 'REJECTED';
  notes?: string;
  createdBy?: string;
  discountAdjustment?: number;
  amountAbsorbedFromDebt?: number;
  amountRefundedInCash?: number;
}

export interface AvoirPageResponse {
  content: Avoir[];
  totalPages: number;
  totalElements: number;
  size: number;
  number: number;
}

@Injectable({
  providedIn: 'root'
})
export class AvoirService {
  private apiUrl = environment.apiUrl + '/avoirs';

  constructor(private http: HttpClient) {}

  getAvoirById(id: number): Observable<Avoir> {
    return this.http.get<Avoir>(`${this.apiUrl}/${id}`);
  }

  getAvoirsByOrderId(orderId: number): Observable<Avoir[]> {
    return this.http.get<Avoir[]>(`${this.apiUrl}/order/${orderId}`);
  }

  getPagedAvoirs(page: number, size: number, keyword?: string, date?: string): Observable<AvoirPageResponse> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());

    if (keyword) {
      params = params.set('keyword', keyword);
    }
    if (date) {
      params = params.set('date', date);
    }

    return this.http.get<AvoirPageResponse>(`${this.apiUrl}/page`, { params });
  }

  createAvoir(avoir: Avoir): Observable<Avoir> {
    return this.http.post<Avoir>(this.apiUrl, avoir);
  }

  updateAvoir(id: number, avoir: Avoir): Observable<Avoir> {
    return this.http.put<Avoir>(`${this.apiUrl}/${id}`, avoir);
  }

  approveAvoir(id: number): Observable<Avoir> {
    return this.http.put<Avoir>(`${this.apiUrl}/${id}/approve`, {});
  }

  deleteAvoir(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
